import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { MobileAppPtiRanking } from '../models/mobileAppPtiRanking';

@Component({
  template: ` <div
    class="d-flex overflow-hidden text-overflow-ellipsis justify-content-start align-items-center"
  >
    <a
      [routerLink]="insightsRouterLink"
      [queryParams]="insightsQueryParamsRouterLink"
    >
      <img
        src="{{ data?.appIcon }}"
        alt="{{ data?.appTitle }} Icon"
        class="mr-2 rounded"
        [attr.width]="reportId !== 'mfaIndex' ? '48' : '64'"
        [attr.height]="reportId !== 'mfaIndex' ? '48' : '64'"
        (error)="imageNotFound($event)"
      />
    </a>
    <div class="overflow-hidden">
      <a
        class="btn btn-link title p-0"
        enTooltip
        [attr.title]="data?.appTitle"
        [routerLink]="insightsRouterLink"
        [queryParams]="insightsQueryParamsRouterLink"
      >
        {{ data?.appTitle }}
      </a>
      <div class="publisherName overflow-hidden text-overflow-ellipsis">
        <a
          [attr.title]="data?.publisherName"
          enTooltip
          [routerLink]="discoveryRouterLink"
          [queryParams]="{ developerName: data?.publisherName }"
        >
          {{ data?.publisherName }}
        </a>
      </div>
      <div *ngIf="reportId === 'mfaIndex'">
        <img
          height="24"
          src="/assets/images/google-play.svg"
          alt="Google Play Icon"
          *ngIf="data?.platformName === 'android'"
        />
        <img
          height="24"
          src="/assets/images/apple.svg"
          alt="App Store Icon"
          *ngIf="data?.platformName === 'ios'"
        />
        <img
          height="24"
          src="/assets/images/roku.png"
          alt="Roku Icon"
          *ngIf="data?.platformName === 'roku'"
        />
        <img
          height="24"
          src="/assets/images/firetv.png"
          alt="Fire TV Icon"
          *ngIf="data?.platformName === 'firetv'"
        />
        <img
          height="24"
          src="/assets/images/samsung.png"
          alt="Samsung Icon"
          *ngIf="data?.platformName === 'samsung'"
        />
        <img
          height="24"
          src="/assets/images/tvos.png"
          alt="tvOS Icon"
          *ngIf="data?.platformName === 'tvos'"
        />
        <img
          height="24"
          src="/assets/images/lgtv.png"
          alt="LG TV Icon"
          *ngIf="data?.platformName === 'lgtv'"
        />
      </div>
    </div>
  </div>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppNameComponent extends DataWidgetComponent implements OnInit {
  @Input()
  data: MobileAppPtiRanking;

  ngOnInit(): void {
    super.ngOnInit();
  }

  imageNotFound(event: any) {
    this.data.appIcon = '/assets/icons/icon-72x72-grey.png';
  }
}
